// extracted by mini-css-extract-plugin
export default {"card":"robotics_card__dSJJt"};